export const REQUEST_LINK = 'PASSWORD_RESET/REQUEST_LINK';
export const RESET = 'PASSWORD_RESET/RESET';
export const SENDING = 'PASSWORD_RESET/SENDING';
export const DONE = 'PASSWORD_RESET/DONE';
export const FAILED = 'PASSWORD_RESET/FAILED';
